module.exports = __webpack_public_path__ + "img/vk.b37140a4.svg";